/* eslint-disable */

<template>
  <div>
    <div class="vx-row">
      <!-- Left: switcher + task checklist -->
      <div class="vx-col lg:w-4/12 md:w-5/12 sm:w-5/5 mb-4">
        <div class="flex gap-2 mb-2">
          <vs-button :color="selectedSwitch === 'sw1' ? 'primary' : 'grey'" type="filled" class="flex-1" @click="selectedSwitch = 'sw1'">SW-1</vs-button>
          <vs-button :color="selectedSwitch === 'sw2' ? 'primary' : 'grey'" :disabled="!sw1Unlocked" type="filled" class="flex-1" @click="selectedSwitch = 'sw2'">SW-2</vs-button>
        </div>
        <vx-card style="height: 42rem; overflow-y: auto">

          <!-- Task 1 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{ border: '1px solid ' + (task1Done ? '#28C76F' : '#3a3f51') }">
            <div class="flex items-center gap-2 px-3 py-2" :style="{ background: task1Done ? 'rgba(40,199,111,0.08)' : 'rgba(255,255,255,0.03)' }">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{ width:'20px', height:'20px', fontSize:'10px', background: task1Done ? '#28C76F' : '#4a5568' }">1</span>
              <span class="font-semibold text-sm flex-1">Configure SW-1 VLAN 15 — OPS</span>
              <span class="text-xs font-medium" :class="task1Done ? 'text-success' : 'text-grey'">{{ task1Items.filter(i => sw1Completion[i.key]).length }}/{{ task1Items.length }}</span>
            </div>
            <div class="px-3 py-2 space-y-1">
              <div v-for="item in task1Items" :key="'t1-' + item.key" class="flex items-center gap-2">
                <div class="flex-shrink-0 rounded-full" :style="dot(sw1Completion[item.key])"></div>
                <code class="text-base" :class="sw1Completion[item.key] ? 'text-success' : ''">{{ item.cmd }}</code>
              </div>
            </div>
          </div>

          <!-- Task 2 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{ border: '1px solid ' + (task2Done ? '#28C76F' : '#3a3f51') }">
            <div class="flex items-center gap-2 px-3 py-2" :style="{ background: task2Done ? 'rgba(40,199,111,0.08)' : 'rgba(255,255,255,0.03)' }">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{ width:'20px', height:'20px', fontSize:'10px', background: task2Done ? '#28C76F' : '#4a5568' }">2</span>
              <span class="font-semibold text-sm flex-1">Configure SW-2 VLAN 66 — ENGINEERING</span>
              <span class="text-xs font-medium" :class="task2Done ? 'text-success' : 'text-grey'">{{ task2Items.filter(i => sw2Completion[i.key]).length }}/{{ task2Items.length }}</span>
            </div>
            <div class="px-3 py-2 space-y-1">
              <div v-for="item in task2Items" :key="'t2-' + item.key" class="flex items-center gap-2">
                <div class="flex-shrink-0 rounded-full" :style="dot(sw2Completion[item.key])"></div>
                <code class="text-base" :class="sw2Completion[item.key] ? 'text-success' : ''">{{ item.cmd }}</code>
              </div>
            </div>
          </div>

          <!-- Task 3 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{ border: '1px solid ' + (task3Done ? '#28C76F' : '#3a3f51') }">
            <div class="flex items-center gap-2 px-3 py-2" :style="{ background: task3Done ? 'rgba(40,199,111,0.08)' : 'rgba(255,255,255,0.03)' }">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{ width:'20px', height:'20px', fontSize:'10px', background: task3Done ? '#28C76F' : '#4a5568' }">3</span>
              <span class="font-semibold text-sm flex-1">SW-1 Port — PC1</span>
              <span class="text-xs font-medium" :class="task3Done ? 'text-success' : 'text-grey'">{{ task3Items.filter(i => sw1Completion[i.key]).length }}/{{ task3Items.length }}</span>
            </div>
            <div class="px-3 py-2 space-y-1">
              <div v-for="item in task3Items" :key="'t3-' + item.key" class="flex items-center gap-2">
                <div class="flex-shrink-0 rounded-full" :style="dot(sw1Completion[item.key])"></div>
                <code class="text-base" :class="sw1Completion[item.key] ? 'text-success' : ''">{{ item.cmd }}</code>
              </div>
            </div>
          </div>

          <!-- Task 4 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{ border: '1px solid ' + (task4Done ? '#28C76F' : '#3a3f51') }">
            <div class="flex items-center gap-2 px-3 py-2" :style="{ background: task4Done ? 'rgba(40,199,111,0.08)' : 'rgba(255,255,255,0.03)' }">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{ width:'20px', height:'20px', fontSize:'10px', background: task4Done ? '#28C76F' : '#4a5568' }">4</span>
              <span class="font-semibold text-sm flex-1">SW-2 Port — PC2</span>
              <span class="text-xs font-medium" :class="task4Done ? 'text-success' : 'text-grey'">{{ task4Items.filter(i => sw2Completion[i.key]).length }}/{{ task4Items.length }}</span>
            </div>
            <div class="px-3 py-2 space-y-1">
              <div v-for="item in task4Items" :key="'t4-' + item.key" class="flex items-center gap-2">
                <div class="flex-shrink-0 rounded-full" :style="dot(sw2Completion[item.key])"></div>
                <code class="text-base" :class="sw2Completion[item.key] ? 'text-success' : ''">{{ item.cmd }}</code>
              </div>
            </div>
          </div>

          <!-- Task 5 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{ border: '1px solid ' + (task5Done ? '#28C76F' : '#3a3f51') }">
            <div class="flex items-center gap-2 px-3 py-2" :style="{ background: task5Done ? 'rgba(40,199,111,0.08)' : 'rgba(255,255,255,0.03)' }">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{ width:'20px', height:'20px', fontSize:'10px', background: task5Done ? '#28C76F' : '#4a5568' }">5</span>
              <span class="font-semibold text-sm flex-1">Configure CDP &amp; LLDP — Both Switches</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="swKey in ['sw1','sw2']" :key="swKey" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background: rgba(255,255,255,0.07); letter-spacing: 0.05em">{{ swKey === 'sw1' ? 'SW-1' : 'SW-2' }}</span>
                <div class="space-y-1 ml-1">
                  <div v-for="item in task5Items" :key="swKey + '-' + item.key" class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot((swKey==='sw1' ? sw1Completion : sw2Completion)[item.key])"></div>
                    <code class="text-base" :class="(swKey==='sw1' ? sw1Completion : sw2Completion)[item.key] ? 'text-success' : ''">{{ item.cmd }}</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Verification -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{ border: '1px solid ' + (verifyDone ? '#28C76F' : '#3a3f51') }">
            <div class="flex items-center gap-2 px-3 py-2" :style="{ background: verifyDone ? 'rgba(40,199,111,0.08)' : 'rgba(255,255,255,0.03)' }">
              <feather-icon :icon="verifyDone ? 'CheckCircleIcon' : 'CircleIcon'" :svgClasses="verifyDone ? 'text-success' : 'text-grey'" size="16" class="flex-shrink-0" />
              <span class="font-semibold text-sm flex-1">Verification</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="swKey in ['sw1','sw2']" :key="swKey" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background: rgba(255,255,255,0.07); letter-spacing: 0.05em">{{ swKey === 'sw1' ? 'SW-1' : 'SW-2' }}</span>
                <div class="space-y-1 ml-1">
                  <div v-for="item in verifyItems" :key="swKey + '-v-' + item.key" class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot((swKey==='sw1' ? sw1Completion : sw2Completion)[item.key])"></div>
                    <code class="text-base" :class="(swKey==='sw1' ? sw1Completion : sw2Completion)[item.key] ? 'text-success' : ''">{{ item.cmd }}</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Save -->
          <div class="rounded-lg mb-2 overflow-hidden" :style="{ border: '1px solid ' + (saveDone ? '#28C76F' : '#3a3f51') }">
            <div class="flex items-center gap-2 px-3 py-2" :style="{ background: saveDone ? 'rgba(40,199,111,0.08)' : 'rgba(255,255,255,0.03)' }">
              <feather-icon :icon="saveDone ? 'CheckCircleIcon' : 'CircleIcon'" :svgClasses="saveDone ? 'text-success' : 'text-grey'" size="16" class="flex-shrink-0" />
              <span class="font-semibold text-sm flex-1">Save Configuration</span>
              <span class="text-xs font-medium" :class="saveDone ? 'text-success' : 'text-grey'">{{ [sw1Completion.saved, sw2Completion.saved].filter(Boolean).length }}/2</span>
            </div>
            <div class="px-3 py-2 space-y-1">
              <div v-for="sw in ['SW-1','SW-2']" :key="sw" class="flex items-center gap-2">
                <div class="flex-shrink-0 rounded-full" :style="dot(sw==='SW-1' ? sw1Completion.saved : sw2Completion.saved)"></div>
                <code class="text-base" :class="(sw==='SW-1' ? sw1Completion.saved : sw2Completion.saved) ? 'text-success' : ''">copy running-config startup-config</code>
                <span class="text-xs text-grey ml-auto">{{ sw }}</span>
              </div>
            </div>
          </div>

        </vx-card>
      </div>

      <!-- Right: Terminals -->
      <div class="vx-col lg:w-8/12 md:w-7/12 sm:w-5/5">
        <div style="height: 35rem">
          <vue-command v-show="selectedSwitch === 'sw1'" key="sw1" id="sw1_terminal" :commands="sw1Commands" :prompt="sw1Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color: #111111; border: 1px solid #181d2a; border-radius: 0.5rem; height: 100%" title="SW-1" />
          <vue-command v-show="selectedSwitch === 'sw2'" key="sw2" id="sw2_terminal" :commands="sw2Commands" :prompt="sw2Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color: #111111; border: 1px solid #181d2a; border-radius: 0.5rem; height: 100%" title="SW-2" />
        </div>

        <!-- Topology -->
        <div class="topology-card">
          <img :src="topologyImage" alt="Network topology" class="topology-img" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueCommand, { createStdout, createStderr } from 'vue-command';
import 'vue-command/dist/vue-command.css';

const HELP_TEXT =
  'Commands:<br>' +
  '&nbsp;vlan [id] | name [vlan-name]<br>' +
  '&nbsp;interface [e0/x] | int [e0/x]<br>' +
  '&nbsp;switchport mode access<br>' +
  '&nbsp;switchport access vlan [id]<br>' +
  '&nbsp;no shutdown | no shut<br>' +
  '&nbsp;lldp run | cdp run<br>' +
  '&nbsp;lldp transmit | lldp receive<br>' +
  '&nbsp;no lldp transmit | no lldp receive<br>' +
  '&nbsp;cdp enable | no cdp enable<br>' +
  '&nbsp;show cdp interface | show lldp interface<br>' +
  '&nbsp;copy running-config startup-config<br>' +
  '&nbsp;exit | end<br>';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      selectedSwitch: 'sw1',
      totalScore: 0,
      topologyImage: 'https://ip-learn.b-cdn.net/simulations/ccna-topologies/VLAN_CDP_LLDP.png',

      task1Items: [
        { key: 'vlanCreated', cmd: 'vlan 15' },
        { key: 'vlanNamed',   cmd: 'name OPS' },
        { key: 'vlanExited',  cmd: 'exit' },
      ],
      task2Items: [
        { key: 'vlanCreated', cmd: 'vlan 66' },
        { key: 'vlanNamed',   cmd: 'name ENGINEERING' },
        { key: 'vlanExited',  cmd: 'exit' },
      ],
      task3Items: [
        { key: 'intE01',       cmd: 'int e0/1' },
        { key: 'e01AccessMode',cmd: 'switchport mode access' },
        { key: 'e01Vlan',      cmd: 'switchport access vlan 15' },
        { key: 'e01NoShut',    cmd: 'no shut' },
        { key: 'e01Exited',    cmd: 'exit' },
      ],
      task4Items: [
        { key: 'intE01',       cmd: 'int e0/1' },
        { key: 'e01AccessMode',cmd: 'switchport mode access' },
        { key: 'e01Vlan',      cmd: 'switchport access vlan 66' },
        { key: 'e01NoShut',    cmd: 'no shut' },
        { key: 'e01Exited',    cmd: 'exit' },
      ],
      task5Items: [
        { key: 'lldpGlobal',    cmd: 'lldp run' },
        { key: 'cdpGlobal',     cmd: 'cdp run' },
        { key: 'intE02',        cmd: 'int e0/2' },
        { key: 'e02LldpTx',     cmd: 'lldp transmit' },
        { key: 'e02LldpRx',     cmd: 'lldp receive' },
        { key: 'e02NoCdp',      cmd: 'no cdp enable' },
        { key: 'e02Exited',     cmd: 'exit' },
        { key: 'intE00',        cmd: 'int e0/0' },
        { key: 'e00NoLldpTx',   cmd: 'no lldp transmit' },
        { key: 'e00NoLldpRx',   cmd: 'no lldp receive' },
        { key: 'e00CdpEnable',  cmd: 'cdp enable' },
      ],
      verifyItems: [
        { key: 'verifyShowCdp',  cmd: 'show cdp interface' },
        { key: 'verifyShowLldp', cmd: 'show lldp interface' },
      ],

      sw1: { mode: 'exec', currentVlan: null, currentInterface: null, vlans: {}, interfaces: {}, lldpGlobal: false, cdpGlobal: false, saved: false },
      sw2: { mode: 'exec', currentVlan: null, currentInterface: null, vlans: {}, interfaces: {}, lldpGlobal: false, cdpGlobal: false, saved: false },

      sw1Completion: {
        vlanCreated: false, vlanNamed: false, vlanExited: false,
        intE01: false, e01AccessMode: false, e01Vlan: false, e01NoShut: false, e01Exited: false,
        lldpGlobal: false, cdpGlobal: false,
        intE02: false, e02LldpTx: false, e02LldpRx: false, e02NoCdp: false, e02Exited: false,
        intE00: false, e00NoLldpTx: false, e00NoLldpRx: false, e00CdpEnable: false,
        verifyShowCdp: false, verifyShowLldp: false,
        saved: false,
      },
      sw2Completion: {
        vlanCreated: false, vlanNamed: false, vlanExited: false,
        intE01: false, e01AccessMode: false, e01Vlan: false, e01NoShut: false, e01Exited: false,
        lldpGlobal: false, cdpGlobal: false,
        intE02: false, e02LldpTx: false, e02LldpRx: false, e02NoCdp: false, e02Exited: false,
        intE00: false, e00NoLldpTx: false, e00NoLldpRx: false, e00CdpEnable: false,
        verifyShowCdp: false, verifyShowLldp: false,
        saved: false,
      },

      sw1Commands: null,
      sw2Commands: null,
    };
  },

  computed: {
    sw1Prompt() {
      switch (this.sw1.mode) {
        case 'exec':        return 'SW-1#';
        case 'config-vlan': return 'SW-1(config-vlan)#';
        case 'config-if':   return 'SW-1(config-if)#';
        default:            return 'SW-1(config)#';
      }
    },
    sw2Prompt() {
      switch (this.sw2.mode) {
        case 'exec':        return 'SW-2#';
        case 'config-vlan': return 'SW-2(config-vlan)#';
        case 'config-if':   return 'SW-2(config-if)#';
        default:            return 'SW-2(config)#';
      }
    },
    sw1Unlocked() { return this.task1Done; },
    task1Done()   { const c=this.sw1Completion; return c.vlanCreated && c.vlanNamed && c.vlanExited; },
    task2Done()   { const c=this.sw2Completion; return c.vlanCreated && c.vlanNamed && c.vlanExited; },
    task3Done()   { const c=this.sw1Completion; return c.intE01 && c.e01AccessMode && c.e01Vlan && c.e01NoShut && c.e01Exited; },
    task4Done()   { const c=this.sw2Completion; return c.intE01 && c.e01AccessMode && c.e01Vlan && c.e01NoShut && c.e01Exited; },
    task5Done() {
      const keys = ['lldpGlobal','cdpGlobal','intE02','e02LldpTx','e02LldpRx','e02NoCdp','e02Exited','intE00','e00NoLldpTx','e00NoLldpRx','e00CdpEnable'];
      return keys.every(k => this.sw1Completion[k] && this.sw2Completion[k]);
    },
    verifyDone() {
      return this.sw1Completion.verifyShowCdp && this.sw1Completion.verifyShowLldp &&
             this.sw2Completion.verifyShowCdp && this.sw2Completion.verifyShowLldp;
    },
    saveDone() { return this.sw1Completion.saved && this.sw2Completion.saved; },
    sw1Task5Done() {
      const keys = ['lldpGlobal','cdpGlobal','intE02','e02LldpTx','e02LldpRx','e02NoCdp','e02Exited','intE00','e00NoLldpTx','e00NoLldpRx','e00CdpEnable'];
      return keys.every(k => this.sw1Completion[k]);
    },
  },

  watch: {
    task1Done(val)     { if (val && !this.task2Done)  this.switchTo('sw2'); },
    task2Done(val)     { if (val && !this.task3Done)  this.switchTo('sw1'); },
    task3Done(val)     { if (val && !this.task4Done)  this.switchTo('sw2'); },
    task4Done(val)     { if (val)                     this.switchTo('sw1'); },
    sw1Task5Done(val)  { if (val && !this.task5Done)  this.switchTo('sw2'); },
  },

  mounted() {
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);
    const self = this;
    this.sw1Commands = {
      help:       () => createStdout(HELP_TEXT),
      enable:     () => createStdout(''),
      configure:  (x) => self.iosConfigure(self.sw1, x),
      conf:       (x) => self.iosConfigure(self.sw1, x),
      exit:       () => self.iosExit(self.sw1, self.sw1Completion),
      end:        () => self.iosEnd(self.sw1, self.sw1Completion),
      vlan:       (x) => self.iosVlan(self.sw1, self.sw1Completion, { vlanId: 15, vlanName: 'OPS' }, x),
      name:       (x) => self.iosName(self.sw1, self.sw1Completion, { vlanId: 15, vlanName: 'OPS' }, x),
      interface:  (x) => self.iosInt(self.sw1, self.sw1Completion, x),
      int:        (x) => self.iosInt(self.sw1, self.sw1Completion, x),
      switchport: (x) => self.iosSwitchport(self.sw1, self.sw1Completion, 15, x),
      no:         (x) => self.iosNo(self.sw1, self.sw1Completion, x),
      lldp:       (x) => self.iosLldp(self.sw1, self.sw1Completion, x),
      cdp:        (x) => self.iosCdp(self.sw1, self.sw1Completion, x),
      show:       (x) => self.iosShow(self.sw1, self.sw1Completion, x),
      copy:       (x) => self.iosCopy(self.sw1, self.sw1Completion, x),
    };
    this.sw2Commands = {
      help:       () => createStdout(HELP_TEXT),
      enable:     () => createStdout(''),
      configure:  (x) => self.iosConfigure(self.sw2, x),
      conf:       (x) => self.iosConfigure(self.sw2, x),
      exit:       () => self.iosExit(self.sw2, self.sw2Completion),
      end:        () => self.iosEnd(self.sw2, self.sw2Completion),
      vlan:       (x) => self.iosVlan(self.sw2, self.sw2Completion, { vlanId: 66, vlanName: 'ENGINEERING' }, x),
      name:       (x) => self.iosName(self.sw2, self.sw2Completion, { vlanId: 66, vlanName: 'ENGINEERING' }, x),
      interface:  (x) => self.iosInt(self.sw2, self.sw2Completion, x),
      int:        (x) => self.iosInt(self.sw2, self.sw2Completion, x),
      switchport: (x) => self.iosSwitchport(self.sw2, self.sw2Completion, 66, x),
      no:         (x) => self.iosNo(self.sw2, self.sw2Completion, x),
      lldp:       (x) => self.iosLldp(self.sw2, self.sw2Completion, x),
      cdp:        (x) => self.iosCdp(self.sw2, self.sw2Completion, x),
      show:       (x) => self.iosShow(self.sw2, self.sw2Completion, x),
      copy:       (x) => self.iosCopy(self.sw2, self.sw2Completion, x),
    };
  },

  methods: {
    dot(val) {
      return { width:'8px', height:'8px', background: val ? '#28C76F' : 'transparent', border: '2px solid ' + (val ? '#28C76F' : '#6b7280') };
    },
    guide(msg) {
      return `<span style="color:#28C76F;display:block;margin-top:6px;padding:4px 8px;border-left:2px solid #28C76F;font-size:0.85em;line-height:1.5">${msg}</span>`;
    },
    switchTo(sw) {
      this.selectedSwitch = sw;
      this.$nextTick(() => {
        const el = document.querySelector(`#${sw}_terminal input, #${sw}_terminal textarea`);
        if (el) el.focus();
      });
    },

    iosConfigure(state, x) {
      if (state.mode !== 'exec') return createStderr('% Invalid input detected');
      if (x._[1] === 'terminal' || x._[1] === 't') {
        state.mode = 'config';
        return createStdout('Enter configuration commands, one per line.  End with CNTL/Z.');
      }
      return createStderr('% Invalid input detected');
    },

    iosExit(state, completion) {
      let guideMsg = null;
      if (state.mode === 'config-vlan') {
        if (completion.vlanNamed && !completion.vlanExited) {
          completion.vlanExited = true;
          this.updateScore();
          guideMsg = 'VLAN applied to the switch database. → "interface e0/1" to configure the PC access port.';
        }
        state.mode = 'config';
      } else if (state.mode === 'config-if') {
        if (state.currentInterface === 'e0/1' && completion.e01NoShut && !completion.e01Exited) {
          completion.e01Exited = true;
          this.updateScore();
          guideMsg = 'Port configuration complete. → Configure Task 5: "lldp run" then "cdp run".';
        }
        if (state.currentInterface === 'e0/2' && completion.e02NoCdp && !completion.e02Exited) {
          completion.e02Exited = true;
          this.updateScore();
          guideMsg = 'e0/2 configured for LLDP only. → "int e0/0" then disable LLDP and enable CDP on that port.';
        }
        state.mode = 'config';
      } else if (state.mode === 'config') {
        state.mode = 'exec';
      }
      return guideMsg ? createStdout(this.guide(guideMsg)) : createStdout('');
    },

    iosEnd(state, completion) {
      if (state.mode === 'config-vlan' && completion.vlanNamed && !completion.vlanExited) {
        completion.vlanExited = true;
        this.updateScore();
      }
      state.mode = 'exec';
      return createStdout('');
    },

    iosVlan(state, completion, cfg, x) {
      if (state.mode !== 'config') return createStderr('% Invalid input detected — must be in config mode');
      const vlanId = parseInt(x._[1]);
      if (isNaN(vlanId) || vlanId < 1 || vlanId > 4094) return createStderr('% Invalid VLAN ID');
      state.mode = 'config-vlan';
      state.currentVlan = vlanId;
      if (!state.vlans[vlanId]) state.vlans[vlanId] = {};
      if (vlanId === cfg.vlanId && !completion.vlanCreated) {
        completion.vlanCreated = true;
        this.updateScore();
        return createStdout(this.guide(`VLAN ${cfg.vlanId} created. VLANs segment the broadcast domain — all ports in VLAN ${cfg.vlanId} share one isolated broadcast domain. → "name ${cfg.vlanName}" to label it.`));
      }
      return createStdout('');
    },

    iosName(state, completion, cfg, x) {
      if (state.mode !== 'config-vlan') return createStderr('% Invalid input detected');
      const vlanName = x._[1];
      if (!vlanName) return createStderr('% Incomplete command');
      if (!state.vlans[state.currentVlan]) state.vlans[state.currentVlan] = {};
      state.vlans[state.currentVlan].name = vlanName;
      if (state.currentVlan === cfg.vlanId && vlanName === cfg.vlanName && !completion.vlanNamed) {
        completion.vlanNamed = true;
        this.updateScore();
        return createStdout(this.guide(`VLAN ${cfg.vlanId} named ${cfg.vlanName}. → "exit" to apply the VLAN to the switch database.`));
      }
      return createStdout('');
    },

    iosInt(state, completion, x) {
      if (state.mode !== 'config') return createStderr('% Invalid input detected');
      let _ifRaw = String(x._[1] || '');
      if (x._[2] && /^\d+\/\d+/.test(String(x._[2]))) _ifRaw = _ifRaw + x._[2];
      const iface = this.normalizeInterface(_ifRaw);
      if (!iface) return createStderr('% Invalid interface');
      state.mode = 'config-if';
      state.currentInterface = iface;
      if (iface === 'e0/1' && !completion.intE01) {
        completion.intE01 = true;
        this.updateScore();
        return createStdout(this.guide('Entered e0/1 — the PC access port. → "switchport mode access" then "switchport access vlan [id]" then "no shut".'));
      }
      if (iface === 'e0/2' && !completion.intE02) {
        completion.intE02 = true;
        this.updateScore();
        return createStdout(this.guide('Entered e0/2 — this link uses LLDP (IEEE 802.1AB, vendor-neutral) for neighbor discovery. → "lldp transmit" then "lldp receive" then "no cdp enable".'));
      }
      if (iface === 'e0/0' && !completion.intE00) {
        completion.intE00 = true;
        this.updateScore();
        return createStdout(this.guide('Entered e0/0 — the inter-switch link using CDP (Cisco-proprietary) only. → "no lldp transmit" then "no lldp receive" then "cdp enable".'));
      }
      return createStdout('');
    },

    iosSwitchport(state, completion, targetVlan, x) {
      if (state.mode !== 'config-if') return createStderr('% Invalid input detected');
      const iface = state.currentInterface;
      if (!state.interfaces[iface]) state.interfaces[iface] = {};
      if (x._[1] === 'mode' && x._[2] === 'access') {
        state.interfaces[iface].mode = 'access';
        if (iface === 'e0/1' && !completion.e01AccessMode) {
          completion.e01AccessMode = true;
          this.updateScore();
          return createStdout(this.guide(`Port set to access mode — the connected PC sends and receives untagged frames. Frames are internally tagged as VLAN ${targetVlan} by the switch. → "switchport access vlan ${targetVlan}".`));
        }
        return createStdout('');
      }
      if (x._[1] === 'access' && x._[2] === 'vlan') {
        const vId = parseInt(x._[3]);
        state.interfaces[iface].accessVlan = vId;
        if (iface === 'e0/1' && vId === targetVlan && !completion.e01Vlan) {
          completion.e01Vlan = true;
          this.updateScore();
          return createStdout(this.guide(`Port assigned to VLAN ${targetVlan}. The PC is now in this VLAN's broadcast domain. → "no shut" to bring the port up.`));
        }
        return createStdout('');
      }
      return createStderr('% Invalid input detected');
    },

    iosNo(state, completion, x) {
      if (state.mode !== 'config-if') return createStderr('% Invalid input detected');
      const iface = state.currentInterface;
      if (!state.interfaces[iface]) state.interfaces[iface] = {};
      const sub = x._[1], sub2 = x._[2];

      if (sub === 'shutdown' || sub === 'shut') {
        state.interfaces[iface].shutdown = false;
        if (iface === 'e0/1' && !completion.e01NoShut) {
          completion.e01NoShut = true;
          this.updateScore();
          return createStdout(
            `%LINK-5-CHANGED: Interface Ethernet${iface.substring(1)}, changed state to up<br>` +
            `%LINEPROTO-5-UPDOWN: Line protocol on Interface Ethernet${iface.substring(1)}, changed state to up` +
            this.guide('Port is now up — the PC can communicate on this VLAN. → "exit" to complete the port configuration.')
          );
        }
        return createStdout(
          `%LINK-5-CHANGED: Interface Ethernet${iface.substring(1)}, changed state to up<br>` +
          `%LINEPROTO-5-UPDOWN: Line protocol on Interface Ethernet${iface.substring(1)}, changed state to up`
        );
      }

      if (sub === 'cdp' && sub2 === 'enable') {
        state.interfaces[iface].cdp = false;
        if (iface === 'e0/2' && !completion.e02NoCdp) {
          completion.e02NoCdp = true;
          this.updateScore();
          return createStdout(this.guide('CDP disabled on e0/2. This port now uses LLDP only for neighbor discovery — CDP advertisements are suppressed here. → "exit" then "int e0/0" for the CDP-only port.'));
        }
        return createStdout('');
      }

      if (sub === 'lldp' && sub2 === 'transmit') {
        state.interfaces[iface].lldpTx = false;
        if (iface === 'e0/0' && !completion.e00NoLldpTx) {
          completion.e00NoLldpTx = true;
          this.updateScore();
          return createStdout(this.guide('LLDP TX disabled on e0/0. The inter-switch link will not send LLDP advertisements. → "no lldp receive".'));
        }
        return createStdout('');
      }

      if (sub === 'lldp' && sub2 === 'receive') {
        state.interfaces[iface].lldpRx = false;
        if (iface === 'e0/0' && !completion.e00NoLldpRx) {
          completion.e00NoLldpRx = true;
          this.updateScore();
          return createStdout(this.guide('LLDP RX disabled on e0/0. CDP is now the only discovery protocol on this port. → "cdp enable" to explicitly confirm CDP.'));
        }
        return createStdout('');
      }

      return createStderr('% Invalid input detected');
    },

    iosLldp(state, completion, x) {
      const iface = state.currentInterface;
      if (state.mode === 'config' && x._[1] === 'run') {
        state.lldpGlobal = true;
        if (!completion.lldpGlobal) {
          completion.lldpGlobal = true;
          this.updateScore();
          return createStdout(this.guide('LLDP enabled globally. LLDP (IEEE 802.1AB) is the vendor-neutral L2 neighbor discovery standard — it works with non-Cisco equipment, unlike CDP. → "cdp run" to also enable CDP globally.'));
        }
        return createStdout('');
      }
      if (state.mode === 'config-if' && iface) {
        if (!state.interfaces[iface]) state.interfaces[iface] = {};
        if (x._[1] === 'transmit') {
          state.interfaces[iface].lldpTx = true;
          if (iface === 'e0/2' && !completion.e02LldpTx) {
            completion.e02LldpTx = true;
            this.updateScore();
            return createStdout(this.guide('LLDP TX enabled on e0/2. This port now sends LLDP advertisements — neighbors can discover this switch via LLDP. → "lldp receive".'));
          }
          return createStdout('');
        }
        if (x._[1] === 'receive') {
          state.interfaces[iface].lldpRx = true;
          if (iface === 'e0/2' && !completion.e02LldpRx) {
            completion.e02LldpRx = true;
            this.updateScore();
            return createStdout(this.guide('LLDP RX enabled on e0/2. Both LLDP directions are active. → "no cdp enable" to disable CDP on this LLDP port.'));
          }
          return createStdout('');
        }
      }
      return createStderr('% Invalid input detected');
    },

    iosCdp(state, completion, x) {
      const iface = state.currentInterface;
      if (state.mode === 'config' && x._[1] === 'run') {
        state.cdpGlobal = true;
        if (!completion.cdpGlobal) {
          completion.cdpGlobal = true;
          this.updateScore();
          return createStdout(this.guide('CDP enabled globally. CDP is Cisco-proprietary — only Cisco devices understand it. → "int e0/2" to configure per-interface LLDP/CDP settings.'));
        }
        return createStdout('');
      }
      if (state.mode === 'config-if' && x._[1] === 'enable' && iface) {
        if (!state.interfaces[iface]) state.interfaces[iface] = {};
        state.interfaces[iface].cdp = true;
        if (iface === 'e0/0' && !completion.e00CdpEnable) {
          completion.e00CdpEnable = true;
          this.updateScore();
          return createStdout(this.guide('CDP explicitly enabled on e0/0. The inter-switch link now uses CDP only for neighbor discovery. → "end" then verify with "show cdp interface" and "show lldp interface".'));
        }
        return createStdout('');
      }
      return createStderr('% Invalid input detected');
    },

    iosShow(state, completion, x) {
      if (state.mode !== 'exec') return createStderr('% Use "end" or "exit" to return to privileged EXEC mode first');
      const sub = x._[1], sub2 = x._[2];

      if (sub === 'cdp' && sub2 === 'interface') {
        if (!state.cdpGlobal) return createStdout('% CDP is not enabled');
        let out = '';
        ['e0/0', 'e0/1', 'e0/2'].forEach(i => {
          const disabled = state.interfaces[i] && state.interfaces[i].cdp === false;
          if (!disabled) {
            out += `Ethernet${i.substring(1)} is up, line protocol is up<br>`;
            out += `&nbsp;&nbsp;Encapsulation ARPA&nbsp;&nbsp;Sending CDP packets every 60 seconds<br>`;
            out += `&nbsp;&nbsp;Holdtime is 180 seconds<br>`;
          }
        });
        if (!out) out = '% CDP is not enabled on any interfaces<br>';
        if (!completion.verifyShowCdp) { completion.verifyShowCdp = true; this.updateScore(); }
        return createStdout(out + this.guide('CDP verified — e0/2 should NOT appear (CDP disabled there) and e0/0/e0/1 should appear. → "show lldp interface".'));
      }

      if (sub === 'lldp' && sub2 === 'interface') {
        if (!state.lldpGlobal) return createStdout('% LLDP is not enabled');
        let out = '';
        ['e0/0', 'e0/1', 'e0/2'].forEach(i => {
          const tx = state.interfaces[i] && state.interfaces[i].lldpTx;
          const rx = state.interfaces[i] && state.interfaces[i].lldpRx;
          if (tx || rx) {
            out += `Et${i.substring(1)}:<br>`;
            out += `&nbsp;&nbsp;&nbsp;&nbsp;Tx: ${tx ? 'enabled' : 'disabled'}<br>`;
            out += `&nbsp;&nbsp;&nbsp;&nbsp;Rx: ${rx ? 'enabled' : 'disabled'}<br>`;
            out += `&nbsp;&nbsp;&nbsp;&nbsp;Tx state: IDLE<br>&nbsp;&nbsp;&nbsp;&nbsp;Rx state: WAIT FOR FRAME<br>`;
          }
        });
        if (!out) out = '% LLDP is not configured on any interfaces<br>';
        if (!completion.verifyShowLldp) { completion.verifyShowLldp = true; this.updateScore(); }
        const otherSaved = completion === this.sw1Completion ? this.sw2Completion.saved : this.sw1Completion.saved;
        return createStdout(out + this.guide('LLDP verified — only e0/2 should show TX/RX enabled (e0/0 should be disabled). → Save: "copy running-config startup-config".'));
      }

      return createStderr('% Invalid input detected');
    },

    iosCopy(state, completion, x) {
      if (state.mode !== 'exec') return createStderr('% Invalid input detected');
      if (x._[1] === 'running-config' && x._[2] === 'startup-config') {
        state.saved = true;
        if (!completion.saved) { completion.saved = true; this.updateScore(); }
        const otherSaved = completion === this.sw1Completion ? this.sw2Completion.saved : this.sw1Completion.saved;
        return createStdout(
          'Building configuration...<br>[OK]' +
          this.guide(otherSaved ? '✓ Both switches saved — simulation complete!' : '→ Save the remaining switch.')
        );
      }
      return createStderr('% Invalid input detected');
    },

    normalizeInterface(raw) {
      if (!raw) return null;
      const s = raw.toLowerCase();
      if (/^(ethernet|e)0\/[0-9]+$/.test(s))            return 'e' + s.replace(/^(ethernet|e)/, '');
      if (/^(fastethernet|fa|f)0\/[0-9]+$/.test(s))     return 'e' + s.replace(/^(fastethernet|fa|f)/, '');
      if (/^(gigabitethernet|gi|g)0\/[0-9]+$/.test(s))  return 'e' + s.replace(/^(gigabitethernet|gi|g)/, '');
      return null;
    },

    updateScore() {
      let score = 0;
      Object.values(this.sw1Completion).forEach(v => { if (v) score++; });
      Object.values(this.sw2Completion).forEach(v => { if (v) score++; });
      this.totalScore = score;
      this.$emit('simulation_update_score', score);
      if (score >= 44) setTimeout(() => this.$emit('simulation_full_correct', score), 500);
    },
  },

  components: { VueCommand },
  props: { data: { type: Object, required: true } },
};
</script>

<style>
#sw1_terminal, #sw2_terminal { overflow: hidden !important; }

.topology-card {
  margin-top: 1.5rem;
  background-color: #111111;
  border: 1px solid #181d2a;
  border-radius: 0.5rem;
  overflow: hidden;
  line-height: 0;
}
.topology-img {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
}
</style>
